import React from 'react';
import { Link } from 'react-router-dom';

function TopFooter() {
  const footerSections = [
    {
      id: 1,
      icon: "/Logo/karachi-loc.webp",
      title: "Karachi Office",
      content: "CENTREX Marine Services 5B-1, 5th Floor, Fakhri Trade Center, Shahrah-e-Liaquat, New Chali Karachi.",
      buttonText: "Contact Now"
    },
  
    {
      id: 3,
      icon: "/Logo/lahore-loc.webp",
      title: "Lahore Office",
      content: "CENTREX Marine Services. House No. 144 E, Meer Street Near Al Fateh Hotel, Maulana Shaukat Ali Road Lahore.",
      buttonText: "Contact Now"
    },
    {
      id: 4,
      icon: "/Logo/sialkot-loc.webp",
      title: "Sialkot Office",
      content: "CENTREX Marine Services. House No. 11-A, Noor Villas Near Al Safari Halls, Kashmir Road Sialkot.",
      buttonText: "Contact Now"
    }
  ];

  // Function to scroll to top when a link is clicked
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="top-footer">
      <div className="top-footer-header">
        <h2>Empowering Growth</h2>
        <p>UNVEILING SOLUTIONS FOR YOUR SUCCESS, CONNECT WITH US TODAY!</p>
      </div>
      
      <div className="footer-sections-container">
        {footerSections.map((section, index) => (
          <React.Fragment key={section.id}>
            <div className="footer-section">
              <div className="footer-icon">
                <img src={section.icon} alt={section.title} className="footer-icon-image" />
              </div>
              <h3 className="footer-section-title">{section.title}</h3>
              <p className="footer-section-content">{section.content}</p>
              {section.contentb && <p className="footer-section-content">{section.contentb}</p>}
              <Link 
                to="/contact" 
                className="footer-section-button"
                onClick={scrollToTop}
              >
                {section.buttonText}
              </Link>
            </div>
            {index < footerSections.length - 1 && <div className="footer-divider"></div>}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default TopFooter;
